import { Toast as BaseToast } from "@base-ui/react/toast";
import { CircleAlert, CircleCheck, Info, X } from "lucide-react";
import type { ReactNode } from "react";
import { cn } from "../utils";

export const useToast = BaseToast.useToastManager;

const TYPE_ICONS: Record<string, ReactNode> = {
  success: <CircleCheck className="size-4 text-success" />,
  error: <CircleAlert className="size-4 text-danger" />,
  info: <Info className="size-4 text-info" />,
};

function ToastList() {
  const { toasts } = BaseToast.useToastManager();
  return toasts.map((toast) => (
    <BaseToast.Root
      key={toast.id}
      toast={toast}
      className={cn(
        "pointer-events-auto flex w-80 items-start gap-2.5 rounded-surface border border-line",
        "bg-surface-overlay p-3 shadow-overlay",
        "transition-[transform,opacity] duration-200 ease-swift",
        "data-[starting-style]:translate-y-2 data-[starting-style]:opacity-0",
        "data-[ending-style]:translate-y-2 data-[ending-style]:opacity-0",
      )}
    >
      {toast.type && TYPE_ICONS[toast.type]}
      <div className="flex min-w-0 flex-1 flex-col gap-0.5">
        <BaseToast.Title className="text-[0.8125rem] font-medium text-ink" />
        <BaseToast.Description className="text-2xs text-ink-muted" />
      </div>
      <BaseToast.Close
        className="rounded-control p-0.5 text-ink-muted transition-colors hover:bg-surface-sunken hover:text-ink"
        aria-label="Fechar"
      >
        <X className="size-3.5" />
      </BaseToast.Close>
    </BaseToast.Root>
  ));
}

export function Toaster({ children }: { children: ReactNode }) {
  return (
    <BaseToast.Provider>
      {children}
      <BaseToast.Portal>
        <BaseToast.Viewport className="fixed bottom-4 right-4 z-[60] flex flex-col gap-2">
          <ToastList />
        </BaseToast.Viewport>
      </BaseToast.Portal>
    </BaseToast.Provider>
  );
}
